import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { ISingleMessage } from './SingleMessage';
import { iconSizeNumber } from './SingleMessage.helpers';
import { titleVariantStyles, eyebrowVariantStyles } from './SingleMessage.styles';
import TAGSvgIcon from '@shared-components/components/TAGSvgIcon';
import { Maybe } from '@shared-components/types';
export interface ISingleMessageHeader {
  icon: ISingleMessage['icon'];
  iconSize: ISingleMessage['iconSize'];
  title: ISingleMessage['title'];
  isTitleCenterAligned?: boolean;
  eyebrow: ISingleMessage['eyebrow'];
  eyebrowSmallScreen?: Maybe<string>;
  isInlineLayout: ISingleMessage['isInlineLayout'];
  isContentCenterAligned?: boolean;
  isSmallScreen?: boolean;
  isDarkBackground?: boolean;
  children?: Maybe<ReactNode>;
  variant?: Maybe<string>;
}
export const TitleComponent = ({
  isSmallScreen,
  isDarkBackground,
  isTitleCenterAligned,
  title,
  variant
}: {
  title: ISingleMessage['title'];
  isTitleCenterAligned?: boolean;
  isSmallScreen?: boolean;
  isDarkBackground?: boolean;
  variant?: Maybe<string>;
}) => {
  return <Typography variant={isSmallScreen ? 'header2' : 'heroMedium'} color={isDarkBackground ? 'text.light' : `primary.dark`} component="h1" sx={{
    ...(variant === 'teamTag' && titleVariantStyles),
    textAlign: isTitleCenterAligned ? 'center' : 'left',
    marginLeft: isTitleCenterAligned ? 'auto' : '',
    marginRight: isTitleCenterAligned ? 'auto' : '',
    marginBottom: '1rem'
  }} data-sentry-element="Typography" data-sentry-component="TitleComponent" data-sentry-source-file="SingleMessageHeader.tsx">
			{title}
		</Typography>;
};
export default function SingleMessageHeader(props: Readonly<ISingleMessageHeader>) {
  const {
    icon,
    isContentCenterAligned,
    isSmallScreen,
    isDarkBackground,
    iconSize,
    eyebrow,
    eyebrowSmallScreen,
    title,
    isTitleCenterAligned,
    variant
  } = props;
  const teamTagVariant = variant === 'teamTag';
  const eyebrowText = isSmallScreen && eyebrowSmallScreen ? eyebrowSmallScreen : eyebrow;
  const resolvedIconSize = iconSize ?? undefined;
  return <>
			{icon && <Box className="single-message-header-icon" data-testid="icon_single_message_container" sx={{
      textAlign: isSmallScreen || isContentCenterAligned ? 'center' : 'left'
    }}>
					<TAGSvgIcon htmlColor={isDarkBackground ? 'neutrals.white' : 'tertiary.main'} data-testid="icon_single_message" icon={icon} size={iconSizeNumber(resolvedIconSize)} />
				</Box>}

			{eyebrow && <Box sx={{
      ...(teamTagVariant && {
        textAlign: {
          md: 'center',
          sm: 'left'
        }
      })
    }} data-testid="text_single_message_eyebrow_container">
					<Typography data-testid="text_single_message_eyebrow" variant={isSmallScreen ? 'bodySmallBook' : 'bodyMediumBook'} color={isDarkBackground ? 'text.light' : 'text.primary'} margin="0.75rem 0" letterSpacing="0.0625rem" sx={{
        ...(teamTagVariant && eyebrowVariantStyles)
      }}>
						{eyebrowText}
					</Typography>
				</Box>}
			{isSmallScreen && variant === 'teamTag' ? <Box width={'100%'} height={'1px'} bgcolor={'#FFF'} sx={{
      marginTop: '20px'
    }} /> : null}
			{title ? <TitleComponent {...{
      isSmallScreen,
      isDarkBackground,
      isTitleCenterAligned,
      title,
      variant
    }} /> : null}
			{props.children}
		</>;
}